/* eslint-disable max-len */
import {
    IAchieveData,
    ILevelDetails,
    ACHIEVE_TYPE,
    IAchieveType,
    ACHIEVE_LEVEL,
    IAchieveLevel,
    ACHIEVE_LEVEL_STATUS,
} from '@/interface';
import {formatDateForTimestamp} from '@/utils/dateUtils';
import TitleRender from './titleRender';
// 达人
import knowledgeExpertLv1 from '@/assets/img/knowledgeExpertLv1.png';
import knowledgeExpertLv2 from '@/assets/img/knowledgeExpertLv2.png';
import knowledgeExpertLv3 from '@/assets/img/knowledgeExpertLv3.png';
import knowledgeExpertLv4 from '@/assets/img/knowledgeExpertLv4.png';
import knowledgeExpertLv5 from '@/assets/img/knowledgeExpertLv5.png';
import knowledgeExpertLv6 from '@/assets/img/knowledgeExpertLv6.png';
import knowledgeExpertNoHaveLv1 from '@/assets/img/knowledgeExpertNoHaveLv1.png';
import knowledgeExpertNoHaveLv2 from '@/assets/img/knowledgeExpertNoHaveLv2.png';
import knowledgeExpertNoHaveLv3 from '@/assets/img/knowledgeExpertNoHaveLv3.png';
import knowledgeExpertNoHaveLv4 from '@/assets/img/knowledgeExpertNoHaveLv4.png';
import knowledgeExpertNoHaveLv5 from '@/assets/img/knowledgeExpertNoHaveLv5.png';
import knowledgeExpertNoHaveLv6 from '@/assets/img/knowledgeExpertNoHaveLv6.png';
import newKnowledgeExpertCardLv1 from '@/assets/img/newKnowledgeExpertCardLv1.png';
import newKnowledgeExpertCardLv2 from '@/assets/img/newKnowledgeExpertCardLv2.png';
import newKnowledgeExpertCardLv3 from '@/assets/img/newKnowledgeExpertCardLv3.png';
import newKnowledgeExpertCardLv4 from '@/assets/img/newKnowledgeExpertCardLv4.png';
import newKnowledgeExpertCardLv5 from '@/assets/img/newKnowledgeExpertCardLv5.png';
import newKnowledgeExpertCardLv6 from '@/assets/img/newKnowledgeExpertCardLv6.png';
// 伯乐
import knowledgeScoutLv1 from '@/assets/img/knowledgeScoutLv1.png';
import knowledgeScoutLv2 from '@/assets/img/knowledgeScoutLv2.png';
import knowledgeScoutLv3 from '@/assets/img/knowledgeScoutLv3.png';
import knowledgeScoutLv4 from '@/assets/img/knowledgeScoutLv4.png';
import knowledgeScoutLv5 from '@/assets/img/knowledgeScoutLv5.png';
import knowledgeScoutLv6 from '@/assets/img/knowledgeScoutLv6.png';
import knowledgeScoutNoHaveLv1 from '@/assets/img/knowledgeScoutNoHaveLv1.png';
import knowledgeScoutNoHaveLv2 from '@/assets/img/knowledgeScoutNoHaveLv2.png';
import knowledgeScoutNoHaveLv3 from '@/assets/img/knowledgeScoutNoHaveLv3.png';
import knowledgeScoutNoHaveLv4 from '@/assets/img/knowledgeScoutNoHaveLv4.png';
import knowledgeScoutNoHaveLv5 from '@/assets/img/knowledgeScoutNoHaveLv5.png';
import knowledgeScoutNoHaveLv6 from '@/assets/img/knowledgeScoutNoHaveLv6.png';
import newKnowledgeScoutCardLv1 from '@/assets/img/newKnowledgeScoutCardLv1.png';
import newKnowledgeScoutCardLv2 from '@/assets/img/newKnowledgeScoutCardLv2.png';
import newKnowledgeScoutCardLv3 from '@/assets/img/newKnowledgeScoutCardLv3.png';
import newKnowledgeScoutCardLv4 from '@/assets/img/newKnowledgeScoutCardLv4.png';
import newKnowledgeScoutCardLv5 from '@/assets/img/newKnowledgeScoutCardLv5.png';
import newKnowledgeScoutCardLv6 from '@/assets/img/newKnowledgeScoutCardLv6.png';

export const getAchieveSvg = (
    level: IAchieveData['level'],
    type: IAchieveData['type'],
    isNoHave?: boolean,
    isExposed?: boolean
) => {
    // 未获得的
    const knowledgeScoutNoHaveSvg = {
        [`${ACHIEVE_LEVEL.level1}`]: knowledgeScoutNoHaveLv1,
        [`${ACHIEVE_LEVEL.level2}`]: knowledgeScoutNoHaveLv2,
        [`${ACHIEVE_LEVEL.level3}`]: knowledgeScoutNoHaveLv3,
        [`${ACHIEVE_LEVEL.level4}`]: knowledgeScoutNoHaveLv4,
        [`${ACHIEVE_LEVEL.level5}`]: knowledgeScoutNoHaveLv5,
        [`${ACHIEVE_LEVEL.level6}`]: knowledgeScoutNoHaveLv6,
    };
    const knowledgeExpertNoHaveSvg = {
        [`${ACHIEVE_LEVEL.level1}`]: knowledgeExpertNoHaveLv1,
        [`${ACHIEVE_LEVEL.level2}`]: knowledgeExpertNoHaveLv2,
        [`${ACHIEVE_LEVEL.level3}`]: knowledgeExpertNoHaveLv3,
        [`${ACHIEVE_LEVEL.level4}`]: knowledgeExpertNoHaveLv4,
        [`${ACHIEVE_LEVEL.level5}`]: knowledgeExpertNoHaveLv5,
        [`${ACHIEVE_LEVEL.level6}`]: knowledgeExpertNoHaveLv6,
    };
    // 外露小图
    const newKnowledgeScoutCardSvg = {
        [`${ACHIEVE_LEVEL.level1}`]: newKnowledgeScoutCardLv1,
        [`${ACHIEVE_LEVEL.level2}`]: newKnowledgeScoutCardLv2,
        [`${ACHIEVE_LEVEL.level3}`]: newKnowledgeScoutCardLv3,
        [`${ACHIEVE_LEVEL.level4}`]: newKnowledgeScoutCardLv4,
        [`${ACHIEVE_LEVEL.level5}`]: newKnowledgeScoutCardLv5,
        [`${ACHIEVE_LEVEL.level6}`]: newKnowledgeScoutCardLv6,
    };
    const newKnowledgeExpertCardSvg = {
        [`${ACHIEVE_LEVEL.level1}`]: newKnowledgeExpertCardLv1,
        [`${ACHIEVE_LEVEL.level2}`]: newKnowledgeExpertCardLv2,
        [`${ACHIEVE_LEVEL.level3}`]: newKnowledgeExpertCardLv3,
        [`${ACHIEVE_LEVEL.level4}`]: newKnowledgeExpertCardLv4,
        [`${ACHIEVE_LEVEL.level5}`]: newKnowledgeExpertCardLv5,
        [`${ACHIEVE_LEVEL.level6}`]: newKnowledgeExpertCardLv6,
    };
    // 大图和小图共用
    const knowledgeScoutSvg = {
        [`${ACHIEVE_LEVEL.level1}`]: knowledgeScoutLv1,
        [`${ACHIEVE_LEVEL.level2}`]: knowledgeScoutLv2,
        [`${ACHIEVE_LEVEL.level3}`]: knowledgeScoutLv3,
        [`${ACHIEVE_LEVEL.level4}`]: knowledgeScoutLv4,
        [`${ACHIEVE_LEVEL.level5}`]: knowledgeScoutLv5,
        [`${ACHIEVE_LEVEL.level6}`]: knowledgeScoutLv6,
    };
    const knowledgeExpertSvg = {
        [`${ACHIEVE_LEVEL.level1}`]: knowledgeExpertLv1,
        [`${ACHIEVE_LEVEL.level2}`]: knowledgeExpertLv2,
        [`${ACHIEVE_LEVEL.level3}`]: knowledgeExpertLv3,
        [`${ACHIEVE_LEVEL.level4}`]: knowledgeExpertLv4,
        [`${ACHIEVE_LEVEL.level5}`]: knowledgeExpertLv5,
        [`${ACHIEVE_LEVEL.level6}`]: knowledgeExpertLv6,
    };
    // 外露图标和卡片上的图标专用
    if (type === 'knowledgeExpert' && isExposed) {
        return newKnowledgeExpertCardSvg[level];
    }
    if (type === 'knowledgeScout' && isExposed) {
        return newKnowledgeScoutCardSvg[level];
    }
    // 未获得的等级专用
    if (type === 'knowledgeExpert' && isNoHave) {
        return knowledgeExpertNoHaveSvg[level];
    }
    if (type === 'knowledgeScout' && isNoHave) {
        return knowledgeScoutNoHaveSvg[level];
    }
    // 默认使用
    if (type === 'knowledgeExpert') {
        return knowledgeExpertSvg[level];
    }
    if (type === 'knowledgeScout') {
        return knowledgeScoutSvg[level];
    }
};

export const getAchieveTooltipContent = (item: IAchieveData, type: IAchieveType) => {
    const Maps = {
        [`${ACHIEVE_TYPE.knowledgeScout}`]: `${item.name}Lv.${item.level}，累计挖掘高价值文档${item.progress}篇`,
        [`${ACHIEVE_TYPE.knowledgeExpert}`]: `${item.name}Lv.${item.level}，累计创建高价值文档${item.progress}篇`,
    };
    return Maps[type];
};

export const getAchieveDialogConfig = (data: IAchieveData, curLevelData: ILevelDetails, index: number) => {
    const {
        level: curLevel,
        status: curStatus,
        achieveTime: curTime,
        target: curTarget,
    } = curLevelData;
    const isComplete = curStatus === ACHIEVE_LEVEL_STATUS.alreadyGet;
    // const title = `${data.name} Lv.${curLevel}`;
    const title = <TitleRender type={data.type} curLevelData={curLevelData} />;
    const progress = isComplete ?
        `${formatDateForTimestamp(curTime || 0, 'YY-MM-DD')} 已获得` :
        `当前进度 ${data.progress} / ${curTarget}`;
    const Maps = {
        [`${ACHIEVE_TYPE.knowledgeScout}`]: {
            title,
            progress,
            target: isComplete ?
                `累计挖掘高价值文档${data.progress}篇` :
                `达到Lv.${curLevel}需要挖掘高价值文档${curTarget}篇`,
            targetTooltip: '高价值文档指获得大于等于2个币的文档',
        },
        [`${ACHIEVE_TYPE.knowledgeExpert}`]: {
            title,
            progress,
            target: isComplete ?
                `累计创建高价值文档量${data.progress}篇` :
                `达到Lv.${curLevel}需要创建高价值文档${curTarget}篇`,
            targetTooltip: '高价值文档指获得大于等于2个币的文档',

        },
    };
    return Maps[data.type];
};
